import {
  AnneeFormationLibelle,
  ContratAvenantGroupLibelle,
  ModalitePedagogiqueLibelle,
  LieuMobiliteLibelle,
  ConditionRealisationLibelle,
  RegimeSocialLibelle,
  StatutApprentiLibelle,
  TypeQualificationLibelle,
} from '@/features/domaine/types/opco/Demande/CAPP'
import { objectToDropdownItems } from '@/features/interface/shared/tools'
import { BaseCalculFraisLibelle } from '@/features/domaine/types/opco'

export const regimeSocialItems = objectToDropdownItems(RegimeSocialLibelle)
export const baseCalculItems = objectToDropdownItems(BaseCalculFraisLibelle)
export const anneeFormationItems = objectToDropdownItems(AnneeFormationLibelle)
export const contratAvenantGroupItems = objectToDropdownItems(ContratAvenantGroupLibelle)
export const modalitePedagogiqueItems = objectToDropdownItems(ModalitePedagogiqueLibelle)
export const statutApprentiItems = objectToDropdownItems(StatutApprentiLibelle)
export const typeQualificationItems = objectToDropdownItems(TypeQualificationLibelle)
export const lieuMobiliteItems = objectToDropdownItems(LieuMobiliteLibelle)
export const conditionRealisationItems = objectToDropdownItems(ConditionRealisationLibelle)
